import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

/* eslint-disable max-len */
const validation = {
	allowedCharacters: 'Do pole byly zadány nepovolené znaky. ',
	allowedCharactersDocumentId: 'Můžete zadat jen písmena a číslice. ',
	allowedCharactersDocumentIdAttachment: 'Můžete zadat jen číslice nebo číslice začínající písmenem D.',
	allowedCharactersAdministration: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: . - & . ',
	allowedCharactersDate: 'Můžete zadat jen číslice, nebo znaky: . /. ',
	allowedCharactersClaimNo: 'Můžete zadat jen číslice, písmena a-Z, nebo znaky . - /. ',
	allowedCharactersEmail: 'Neplatný formát e-mailové adresy. ',
	allowedCharactersLogin: 'Můžete zadat jen písmena, číslice nebo znaky .  _ \\. ',
	allowedCharactersMunicipality: 'Můžete zadat jen písmena, číslice, mezeru, nebo znaky: . -. ',
	allowedCharactersTitle: 'Můžete zadat jen písmena, mezeru, nebo znaky: . -. ',
	allowedCharactersName: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: , - & . ',
	allowedCharactersNameAsterisk: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: . - & ,*. ',
	allowedCharactersBusinessName: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: . - & , ! @ # $ ( ) ? + : ',
	allowedCharactersNote: 'Do poznámky nelze zadávat znaky " a \' ',
	allowedCharactersPhoneNumber: 'Zadejte telefonní číslo ve formátu +420609111222, 00420609111222 nebo 609111222. ',
	allowedCharactersProposal: 'Můžete zadat jen číslice, nebo znaky: - . / . ',
	allowedCharactersStreet: 'Můžete zadat jen písmena, číslice, mezeru, nebo znaky: . -. ',
	allowedCharactersStreetNumber: 'Můžete zadat jen písmena, číslice, mezeru, nebo znaky: / . -. ',
	allowedCharactersSurname: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: . - & ,. ',
	allowedCharactersSurnameAsterisk: 'Můžete zadat jen písmena, mezeru, číslice nebo znaky: . - & , *. ',
	allowedCharactersContactProduct: 'Můžete zadat jen písmena, čísla, mezeru, nebo znaky: . , - + ( ) % _ / *. ',
	allowedOnlyNumbers: 'Můžete zadat jen číslice. ',
	allowedOnlyNumbersAndCharacters: 'Můžete zadat jen číslice a písmena. ',
	allowedCharactersBusinessCase: 'Nepovolený formát čísla obch. případu. ',
	allowedCharactersDescription: 'Pole obsahuje některý z následujících nepovolených znaků: ;, <, >, $, /, \', ". ',
	allowedCharactersProductPP: 'Do pole byly zadány nepovolené znaky nebo špatný formát. ',
	asteriskInFirstThreeSymbols: 'V prvních 3 znacích nesmíte zadat *. ',
	birthNumberLength: 'Rodné číslo klienta nesmí být kratší než 9 znaků a nesmí být delší než 10 znaků. ',
	communicationDateInPast: 'Hodnota „Datum komunikace od“ musí být menší nebo rovna hodnotě „Datum komunikace do“. ',
	customRequired: 'Nebyly provedeny žádné změny. Data nelze uložit. ',
	customRequiredBusinessCaseNo: 'Pro vybraný typ dokumentu musíte vyplnit ČOP ',
	dateIsNotComplete: 'Datum musí být úplné. Chybí den, měsíc nebo rok.',
	dateInFuture: '{{field}} nesmí být v budoucnosti. ',
	dateInFutureBasic: 'Datum nesmí být v budoucnosti.',
	dateInPast: '{{field}} musí být větší než aktuální datum. ',
	dateMoreThanYearInPastOrInFuture: 'Datum nesmí být v budoucnosti nebo starší než rok od aktuálního data. ',
	dateMoreThanYearInPastConsideringWholeStartingMonthOrInFuture:
		'Datum nesmí být v budoucnosti nebo starší než rok od aktuálního měsíce.',
	dateMoreThanYearInPast: 'Datum nesmí být více jak jeden rok do minulosti.',
	dateMoreThanXYearsInPast_one: 'Datum nesmí být starší než {{count}} rok od aktuálního data.',
	dateMoreThanXYearsInPast_few: 'Datum nesmí být starší než {{count}} roky od aktuálního data.',
	dateMoreThanXYearsInPast_other: 'Datum nesmí být starší než {{count}} let od aktuálního data.',
	dateMustBeInFuture: 'Hodnota musí být větší než aktuální datum.',
	dateMustBeBeforeSpecifiedDate: 'Hodnota nesmí být větší, než “{{field}}“.',
	raDatesWrongOrder: 'Hodnota „Datum vytvoření od“ musí být menší nebo rovna hodnotě „Datum vytvoření do“.',
	datesWrongOrder: 'Hodnota „od“ musí být menší nebo rovna hodnotě „do“. ',
	datesWrongOrderViasDone: 'Hodnota musí být větší než aktuální datum. ',
	datesWrongOrderViasWarning: 'Termín upozornění nesmí být v minulosti. ',
	deadlineDateInPast: 'Hodnota musí být větší než aktuální datum. ',
	emailInputRequired: 'Zadání emailové adresy je povinné.',
	greaterThanZero: 'Zadané pořadové číslo musí být větší než nula. ',
	lengthBetween: 'Musíte zadat {{min}}-{{max}} znaků. ',
	lengthBetweenScope: 'Musíte zadat {{minLength}}-{{maxLength}} znaků. ',
	lengthBetweenNumber: 'Musíte zadat {{min}}-{{max}} číslic. ',
	lengthBetweenForNumbers: 'Musíte zadat {{minLength}}-{{maxLength}} číslic. ',
	lengthExact: 'Musíte zadat {{length}} znaků. ',
	lengthExactUnderFour: 'Musíte zadat {{length}} znaky. ',
	lengthMax: 'Můžete zadat maximálně {{max}} znaků. ',
	newDeadlineDateInPast: 'Hodnota musí být větší než aktuální datum. ',
	notAllowedSpecialCharacters: 'Nemůžete zadat znaky:  ~ ° ! ? @ # $ % =  ^ { } [ ] | \\. ',
	notAllowedSpecialCharactersSemaphoreNote: 'Do poznámky nelze zadávat znaky ~ ° # $  ^ { } [ ] | \\.',
	oneAsterisk: 'Můžete zadat maximálně jednu *. ',
	twoAsterisk: 'Můžete zadat maximálně dvě *. ',
	policyNoLength: 'Číslo pojistné smlouvy nesmí být kratší než 8 znaků a nesmí být delší než 10 znaků. ',
	requiredField: 'Pole {{field}} je povinné. ',
	waringDateGraterThenDeadlineDate: 'Hodnota nesmí být větší, než "Termín splnění". ',
	warningDateInFuture: 'Hodnota musí být větší než aktuální datum. ',
	wrongFormat: 'Nepovolený formát data. ',
	wrongFormatWithExample: 'Nepovolený formát data. Zadejte ve formátu např. 01/02. ',
	wrongPSNumber: 'Hodnota neodpovídá CDV validaci. ',
	wrongPercentage: 'Hodnota musí být celé číslo větší jak 0 a menší nebo rovna 100. ',
	nonPositiveNumber: 'Hodnota musí být celé číslo větší jak 0. ',
	reportDateInPast: 'Hodnota „Datum vykázání od“ musí být menší nebo rovna hodnotě „Datum vykázání do“. ',
	reportDateInFuture: 'Hodnota „Datum vykázání do“ musí být větší nebo rovna hodnotě „Datum vykázání od“. ',
	negotiationDateInPast: 'Hodnota „Datum sjednání od“ musí být menší nebo rovna hodnotě „Datum sjednání do“. ',
	negotiationDateInFuture: 'Hodnota „Datum sjednání do“ musí být větší nebo rovna hodnotě „Datum sjednání od“. ',
	closureDateInPast: 'Hodnota „Datum uzavření od“ musí být menší nebo rovna hodnotě „Datum uzavření do“. ',
	closureDateInFuture: 'Hodnota „Datum uzavření do“ musí být větší nebo rovna hodnotě „Datum uzavření od“. ',
	notAllowedAllNulls: 'Nesmíte zadat pouze nuly. ',
	fileNameExceededMaxLength: 'Název souboru <strong>{{fileName}}</strong> je delší než {{fileNameMaxLength}} znaků.',
	invalidPersonIn: 'Zadané rodné číslo není platné.',
	invalidPersonInNotMatchingGivenBirthDate: 'Datum narození nesouhlasí se zadaným rodným číslem.',
};

export default Object.assign({}, validation, createLabeledMessages(validation));
